import { useEffect, useState } from 'react';

type Size = { width: number; height: number };

// 默认桌面尺寸，服务端和客户端首次渲染保持一致，避免水合错误
const DEFAULT_SIZE: Size = { width: 1024, height: 768 };

const useScreenSize = () => {
  // 初始值始终使用默认值，确保服务端和客户端首次渲染一致
  const [state, setState] = useState<Size>(DEFAULT_SIZE);

  useEffect(() => {
    // 客户端挂载后立即更新为真实尺寸
    setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    // 监听窗口大小变化
    const handleResize = () => {
      setState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return state;
};

export default useScreenSize;
